import type { MailboxInfo } from "owa-client-types";
import { registerAllLightIcons } from "owa-command-ribbon-light-icon-font";
import { once } from "owa-lodash";

import { initializeCommandingViewModeInternalMutator } from "../mutators/initializeCommandingViewModeInternal";
import { onViewModeInitialized } from "../actions/onViewModeInitialized";
import { isSingleLineRibbon } from "../selectors/isSingleLineRibbon";
import { initializeKeytipsEnabledStatus } from "./initializeKeytipsEnabledStatus";
import { registerKeytipsDataCollector } from "./registerKeytipsDataCollector";

export const initializeCommandingViewMode: (primeBootSettingsOptions: any[], mailboxInfo: MailboxInfo) => void = once(function initializeCommandingViewMode(primeBootSettingsOptions: any[], mailboxInfo: MailboxInfo): void {
    initializeCommandingViewModeInternalMutator(primeBootSettingsOptions, mailboxInfo);
    registerAllLightIcons(!isSingleLineRibbon());
    onViewModeInitialized();
    initializeKeytipsEnabledStatus();
    registerKeytipsDataCollector();
});
